// extracted by mini-css-extract-plugin
export default {"formulario":"ContatoPage_formulario__vSyht","btnEnviar":"ContatoPage_btnEnviar__FSnP9"};